export default "__VITE_ASSET__e2ed33d7__"